(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beauty-product-tabs')) {
    customElements.define(
      'beauty-product-tabs',
      class BeautyProductTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
          this.tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => this.select(i));
            tab.addEventListener('keydown', (e) => {
              let n = null;
              if (e.key === 'ArrowRight') n = (i + 1) % this.tabs.length;
              if (e.key === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
              if (n !== null) {
                e.preventDefault();
                this.select(n);
                this.tabs[n].focus();
              }
            });
          });
          this.addEventListener('shopify:block:select', (e) => {
            const i = this.tabs.findIndex((t) => t.id === 'tab-btn-' + e.detail.blockId);
            if (i > -1) this.select(i);
          });
        }
        select(index) {
          this.tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === index ? 'true' : 'false'));
          this.panels.forEach((panel, i) => {
            panel.hidden = i !== index;
          });
          window.dispatchEvent(new Event('resize'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStats(root) {
      if (!root || root.dataset.bsReady === 'true') return;
      root.dataset.bsReady = 'true';

      var animate = root.dataset.animate === 'true';
      var alignText = root.dataset.alignText === 'true';
      var spans = Array.prototype.slice.call(root.querySelectorAll('[data-bs-percent]'));
      if (!spans.length) return;
      var wraps = spans.map(function (span) { return span.parentElement; });
      var targets = spans.map(function (span) {
        return { el: span, target: parseInt(span.dataset.target, 10) || 0, current: 0 };
      });
      var buffer = 10;

      function clearWidths() {
        wraps.forEach(function (wrap) { wrap.style.minWidth = ''; });
      }

      function syncWidths() {
        if (!alignText && !animate) { clearWidths(); return; }
        clearWidths();
        var original = spans.map(function (span) { return span.textContent; });
        targets.forEach(function (t) { t.el.textContent = t.target; });
        if (alignText) {
          var max = 0;
          wraps.forEach(function (wrap) { max = Math.max(max, Math.ceil(wrap.getBoundingClientRect().width)); });
          if (max > 0) wraps.forEach(function (wrap) { wrap.style.minWidth = max + buffer + 'px'; });
        } else {
          wraps.forEach(function (wrap) {
            wrap.style.minWidth = Math.ceil(wrap.getBoundingClientRect().width) + buffer + 'px';
          });
        }
        original.forEach(function (value, i) { spans[i].textContent = value; });
      }

      if (animate) spans.forEach(function (span) { span.textContent = '0'; });
      syncWidths();
      window.addEventListener('resize', syncWidths);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { if (document.body.contains(root)) syncWidths(); });
      }
      if (!animate) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          targets.forEach(function (t) { t.current = 0; t.el.textContent = '0'; });
          var maxValue = Math.max.apply(null, targets.map(function (t) { return t.target; }));
          var seconds = window.innerWidth < 990
            ? parseInt(root.dataset.durationMobile, 10) || 5
            : parseInt(root.dataset.duration, 10) || 5;
          var tick = maxValue > 0 ? Math.max(1, Math.floor((seconds * 1000) / maxValue)) : seconds * 1000;
          var timer = setInterval(function () {
            var done = true;
            targets.forEach(function (t) {
              if (t.current < t.target) {
                t.current++;
                t.el.textContent = t.current;
                done = false;
              }
            });
            if (done) clearInterval(timer);
          }, tick);
        });
      }, { threshold: 0.3 });
      observer.observe(root);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-beauty-stats]').forEach(initStats);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function scrollTrack(root, direction) {
      var track = root.querySelector('[data-bt-track]');
      if (!track) return;
      var slide = track.querySelector('[data-bt-slide]');
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = slide.getBoundingClientRect().width + gap;
      var max = track.scrollWidth - track.clientWidth;
      var atEnd = track.scrollLeft >= max - 2;
      var atStart = track.scrollLeft <= 2;
      if (direction > 0 && atEnd) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        track.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
    }

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-bt-prev], [data-bt-next]');
      if (!button) return;
      var root = button.closest('.beauty-testimonials');
      if (!root) return;
      scrollTrack(root, button.hasAttribute('data-bt-next') ? 1 : -1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
